'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemBuilder = require('./commonMenuItemBuilder');

var _commonMenuItemBuilder2 = _interopRequireDefault(_commonMenuItemBuilder);

var _primaryMenuItem = require('./primaryMenuItem');

var _primaryMenuItem2 = _interopRequireDefault(_primaryMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu Item builder
 * @augments CommonMenuItemBuilder
 * @constructor
 */
/**
 * @module navigation/primaryMenuItemBuilder
 * @requires module: navigation/commonMenuItemBuilder
 * @requires module: navigation/primaryMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function PrimaryMenuItemBuilder() {
  _commonMenuItemBuilder2.default.prototype.constructor.apply(this, arguments);

  this.ItemConstructor = _primaryMenuItem2.default;
  this.activeClass = 'ui-link_selected';

  this.outerClass = 'rn-primaryNav__item';
  this.innerClass = 'rn-primaryNav__link ui-link';
}
PrimaryMenuItemBuilder.prototype = (0, _create2.default)(_commonMenuItemBuilder2.default.prototype);

exports.default = PrimaryMenuItemBuilder;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/primaryMenuItemBuilder.js
// module id = 1783
// module chunks = 1